import React from "react";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import Loader from "../../../widget/common/ui/Loader";
import Center from "../../../widget/common/ui/Center";
import { TextInline } from "../../../widget/common/ui/Text";
import Div from "../../../widget/common/ui/Div";
import { IconCircleFilledIcon } from "../../../widget/common/ui/Icon";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";

const HomeCallBody = () => {
  const contactList = useSelector((state: RootState) => state.home.contactList);

  return (
    <>
      {contactList === undefined ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <Listing>
          {(contactList ?? []).map((contact, key) => (
            <ListItem key={key}>
              <a href={`tel:${contact}`}>
                <Div fontName="book" color="theme-label" fontSize="16_17">
                  <TextInline>
                    <IconCircleFilledIcon size={50} name="call" color="white" />
                  </TextInline>
                  <TextInline className="ps-4">{contact}</TextInline>
                </Div>
              </a>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};
export default HomeCallBody;
